/*
 * Constants for the registration form.
 *
 * The communication language and the Türkiye country id are normally resolved by name from
 * the lists the API serves (GetCommLanguages / GetCountries). These ids are the fallback
 * for when that lookup fails, so we never send an empty communicationLanguageId - the CRM
 * rejects it with CommunicationLanguageNotEmpty.
 *
 * Values verified against the production CommLanguages / Countries tables.
 *
 * Phone validation is not here: components/PhoneInput.vue wraps intl-tel-input, which owns
 * the country list, the dial code, the mask and the validity check, and emits E.164.
 */
export const COMM_LANGUAGE_TR_ID = '0aa8e149-af70-ed11-9562-6045bd8ba4bb'; // Türkçe
export const COMM_LANGUAGE_EN_ID = 'eca7e149-af70-ed11-9562-6045bd8ba4bb'; // İngilizce
export const COUNTRY_TURKIYE_ID = '34a9d9bf-4234-ed11-9db1-6045bd886f15';

export const COMM_LANGUAGE_TR_NAME = 'Türkçe';
export const COMM_LANGUAGE_EN_NAME = 'İngilizce';
export const COUNTRY_TURKIYE_NAME = 'Türkiye';

/** Reasonable e-mail shape: something@something.tld */
export function isValidEmail(value) {
	return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
}

/** Field limits enforced by the CRM validator. */
export const LIMITS = {
	firstName: 40,
	lastName: 40,
	tradeName: 80,
	emailAddress: 241
};
